import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgcCommonModule } from '../../../common/common.module';
// This Module's Components
import { MytripsLoggedInComponent } from './mytrips-logged-in.component';

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    NgcCommonModule,
    FormsModule,
    ModalModule.forRoot(),
    HttpClientModule
  ],
  declarations: [MytripsLoggedInComponent],
  exports: [MytripsLoggedInComponent]
})
export class MytripsLoggedInModule {}
